// Side-effect import for main.tsx: must stay the first import so the SSO
// callback parameters leave the URL before Sentry initialises.
import { captureCallbackParams } from './callbackParams';

captureCallbackParams();
